import { styled, lighten } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";

const StyledDataGridPro = styled(DataGridPro)(({ theme }) => ({
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "transparent", // Désactive le changement de couleur au survol
  },
  "& .custom-error": {
    backgroundColor: lighten(theme.palette.error.light, 0.85),
    "&:hover": {
      backgroundColor: lighten(theme.palette.error.light, 0.85),
    },
  },
  "& .custom-new-row": {
    backgroundColor: lighten(theme.palette.info.light, 0.85),
    "&:hover": {
      backgroundColor: lighten(theme.palette.info.light, 0.85),
    },
  },
}));

const CustomSimpleTable = ({ errors, ...props }) => {
  // Hide the "MUI X Missing license key" warning - waiting for paying for the license
  if (typeof document !== "undefined") {
    const style = document.createElement("style");
    style.innerHTML = `
        div[style*="z-index: 100000"] {
          display: none;
        }
      `;
    document.head.appendChild(style);
  }

  return (
    <StyledDataGridPro
      {...props}
      disableRowSelectionOnClick
      rowHeight={25}
      columnHeaderHeight={25}
      hideFooter
    />
  );
};

export default CustomSimpleTable;
